<script>
import confirmDialog from '@/components/ConfirmDialog.vue';
import AlertComponent from '@/components/AlertComponent.vue';
import AppPageContainer from '@/components/app/PageContainer.vue';
import snackBar from '@/Mixins/snackBar.js';
import ShearedMixin from '@/Mixins/Shared.js';
import ShearedHelper from '@/Helpers/Shared.js';
import pagination from '@/Mixins/Pagination';
import chiefComplaintMixin from '@/Mixins/BaseInformation/ChiefComplaintMixin';
import QuestionMixin from '@/Mixins/BaseInformation/ChiefComplaint/Question.mixin';
import QuestionDTOMixin from '@/Mixins/BaseInformation/ChiefComplaint/dto/Question.dto';
import QuestionHelper from '@/Helpers/BaseInformation/ChiefComplaint/Question.helper';
import StatusSwitcher from '@/components/BaseInformation/ChiefComplaint/StatusSwitcher.vue';
import AppWrapText from '@/components/app/wrapText.vue';
export default {
  inject: ['load', 'tableImg', 'tableTitleImage'],
  components: {
    confirmDialog,
    AlertComponent,
    StatusSwitcher,
    AppWrapText,
    AppPageContainer,
  },
  data: function () {
    return {
      isCreateOrEditModalOpen: false,
      haveReferenceQuestion: false,
    };
  },
  mixins: [
    pagination,
    QuestionMixin,
    ShearedMixin,
    chiefComplaintMixin,
    QuestionHelper,
    snackBar,
    ShearedHelper,
    QuestionDTOMixin,
  ],

  created() {
    this.$root.$refs.ChiefComplaintQuestionManagment = this;
  },
  mounted() {
    this.mounteLoding();
  },
  methods: {
    mounte: function () {
      this.getAllQuestionsHandler();
    },
  },
};
</script>
<template>
  <app-page-container title="سوال ها">
    <template v-slot:header>
      <v-col cols="4" class="mt-3 mr-n16">
        <v-row align="center">
          <v-col class="pl-0">
            <v-btn fab dark small @click="$router.go(-1)" color="darkColor" elevation="0">
              <v-icon dark>mdi-arrow-right mdi-18px</v-icon>
            </v-btn>
          </v-col>
          <v-col cols="8" class="primary-color pr-0">{{ chiefComplaint?.title }}</v-col>
        </v-row>
      </v-col>
      <v-spacer></v-spacer>
      <v-col cols="4" class="">
        <v-text-field outlined rounded placeholder="جستجو..." append-icon="mdi-magnify" dense v-model="searchText"
          class="mt-3"></v-text-field>
      </v-col>
      <v-col cols="3" class="text-left">
        <v-btn v-if="accessDenyAddEditChief" rounded color="darkColor" dark @click="enableAddEditFunction(1, null)"
          class="mt-3 normal-letter-spacing ml-3">
          <v-icon class="ml-1">mdi-plus mdi-18px</v-icon>
          افزودن پرسش کلیدی
        </v-btn>
      </v-col>
    </template>
    <template v-slot:body>
      <v-row no-gutters class="background-main">
        <v-col cols="12" class="pa-0">
          <v-card elevation="0" class="card-width body-card pa-0">
            <v-card-text class="pa-0">
              <v-row no-gutters>
                <v-col cols="12" class="pa-0">
                  <template>
                    <v-data-table v-if="filterdAllQuestions?.length > 0" :headers="chiefComplaintQuestionHeaders"
                      :items="filterdAllQuestions" :page.sync="page" :items-per-page="filterdAllQuestions.length"
                      height="75vh" :hide-default-footer="true" multi-sort class="elevation-0">
                      <template v-slot:[`item.title`]="{ item }">
                        <app-wrap-text :text="item?.title ?? ''" />
                      </template>
                      <template v-slot:[`item.otherChiefComplaintTitle`]="{ item }">
                        <app-wrap-text :text="item?.otherChiefComplaintTitle ?? ''" />
                      </template>
                      <template v-slot:[`item.otherChiefComplaintText`]="{ item }">
                        <app-wrap-text :text="item?.otherChiefComplaintText ?? ''" />
                      </template>
                      <template v-slot:[`item.isActive`]="{ item }">
                        <div @click="accessDenyAddEditChief && changeQuestionStatus(item?.isActive, item?.id)">
                          <status-switcher :value="item?.isActive" />
                        </div>
                      </template>
                      <template v-slot:[`item.actions`]="{ item }">
                        <div class="flex items-center gap-1" v-if="accessDenyAddEditChief">
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                @click="enableAddEditFunction(2, item.id)" v-bind="attrs" v-on="on">
                                mdi-pencil
                              </v-icon>
                            </template>
                            <span>ویرایش</span>
                          </v-tooltip>
                          <v-tooltip top>
                            <template v-slot:activator="{ on, attrs }">
                              <v-icon class="mt-1 mr-5" color="iconColor" style="cursor: pointer"
                                @click="showDeleteConfirmFunction(item.id)" v-bind="attrs" v-on="on">
                                mdi-delete
                              </v-icon>
                            </template>
                            <span>حذف</span>
                          </v-tooltip>
                        </div>
                      </template>
                    </v-data-table>
                    <div v-else>
                      <div>
                        <v-img class="mx-auto" max-height="350" max-width="920"
                          :src="require('@/assets/images/no_data_svg.svg')" />
                      </div>
                      <dir class="text-center headline-5 mt-9">اطلاعاتی برای نمایش وجود ندارد.</dir>
                    </div>
                  </template>
                </v-col>
              </v-row>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </template>
    <template v-slot:append>
      <section>
        <v-dialog width="359" v-model="showAddEditModal" persistent>
          <v-card>
            <v-row no-gutters>
              <v-col cols="12" class="modal-header py-5">
                <v-row no-gutters>
                  <v-spacer></v-spacer>
                  <v-icon color="darkColor">{{ modalIcon }}</v-icon>
                  <span class="modal-title-text mr-2">{{ modalTitle }}</span>
                  <v-spacer></v-spacer>
                </v-row>
              </v-col>
            </v-row>
            <v-card-text class="mt-12">
              <v-row>
                <v-col cols="12">
                  <v-textarea type="text" dense clearable clear-icon="mdi-close-circle-outline" outlined
                    label="عنوان سوال" :autofocus="true" class="input-label" prepend-inner-icon="mdi-text-box mdi-20px"
                    tabindex="1" v-model="chiefComplaintQuestion.title" rows="3"></v-textarea>
                  <v-autocomplete :items="questionPriority" no-data-text="اطلاعاتی وجود ندارد" outlined dense
                    label="اولویت" clearable clear-icon="mdi-close-circle-outline" autocomplete="off"
                    v-model="chiefComplaintQuestion.priority"
                    prepend-inner-icon="mdi-subtitles mdi-20px"></v-autocomplete>
                  <v-checkbox dense v-model="haveReferenceQuestion" label="آیا سوال ارجاعی دارد؟"></v-checkbox>
                </v-col>
                <v-col cols="12" class="">
                  <section v-if="haveReferenceQuestion">
                    <v-autocomplete :items="allChiefComplaints" no-data-text="اطلاعاتی وجود ندارد" outlined
                      label="ارجاع به" clearable item-text="title" item-value="id" clear-icon="mdi-close-circle-outline"
                      autocomplete="off" v-model="chiefComplaintQuestion.otherChiefComplaintId"
                      prepend-inner-icon="mdi-subtitles mdi-20px"></v-autocomplete>
                    <v-textarea type="text" dense clearable clear-icon="mdi-close-circle-outline" outlined
                      label="متن ارجاع" class="input-label" prepend-inner-icon="mdi-text-box mdi-20px"
                      v-model="chiefComplaintQuestion.otherChiefComplaintText" tabindex="1" rows="3"></v-textarea>
                  </section>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions class="mt-2">
              <v-spacer></v-spacer>
              <v-btn color="darkColor" @click="onAcceptModal()" dark rounded class="normal-letter-spacing px-12">
                ثبت
              </v-btn>
              <v-btn rounded color="darkColor" outlined @click="cancelAddEditFunction()"
                class="normal-letter-spacing px-10">
                انصراف
              </v-btn>
              <v-spacer></v-spacer>
            </v-card-actions>
          </v-card>
        </v-dialog>
        <confirm-dialog ref="confirm">
          <v-row slot="action" no-gutters>
            <v-spacer></v-spacer>
            <v-btn color="darkColor" small ref="yes" rounded class="normal-letter-spacing px-12 py-4 ml-2"
              style="color: white" :disabled="disabelConfirm" @click="confirmDialogConfirmFunction">
              بله
            </v-btn>
            <v-btn small rounded text ref="no" class="normal-letter-spacing px-12 confirm-cancel-btn"
              @click="confirmDialogCancelFunction">
              خیر
            </v-btn>
          </v-row>
        </confirm-dialog>
      </section>
      <section>
        <alert-component ref="snackRef" :snakTimeOut="snakTimeOut" :snackColor="snackColor" :snackText="snackText"
          :snakIcon="snakIcon"></alert-component>
      </section>
    </template>
  </app-page-container>
</template>
<style scoped>
.modal-header {
  border-bottom: 2px solid var(--modal-border-color);
  border-bottom-right-radius: 12px !important;
  border-bottom-left-radius: 12px !important;
}

.confirm-cancel-btn {
  border: solid 1px var(--dark-color);
  padding-top: 13px;
  padding-bottom: 15px;
  color: var(--dark-color);
}

.modal-title-text {
  color: var(--dark-color);
  font-weight: 500;
  font-size: 16px;
}

.card-add-phoneNumber {
  border: 2px solid #cdcbcf !important;
}

.card-add-phoneNumber-items {
  margin-top: -7px !important;
}

.card-add-phoneNumber-items-text {
  color: #cdcbcf !important;
}

.body-card {
  overflow-y: auto !important;
}

@media only screen and (min-width: 1280px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1366px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 98.5% !important;
    margin-right: 2vh !important;
  }
}

@media only screen and (min-width: 1536px) {
  .table-content {
    margin-top: 1vh !important;
  }

  .card-width {
    width: 99% !important;
    margin-right: 1vh !important;
  }
}
</style>
